import * as React from "react";
import {
  Columns,
  Column,
  Stack,
  Text,
  Divider,
  Box,
} from "@origin-digital/ods-core";
import ReadOnlyFieldWrapper from "../ReadOnlyFieldWrapper";
import styled from "styled-components";

interface IReadOnlyContactBlockProps {
  contactType: string;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  licenceNumber?: string | undefined;
  type?: string | undefined;
}

const HeadingText = styled(Text)`
  font-weight: 500 !important;
  size: 14px !important;
  line-height: 24px !important;
  color: #505050 !important;
`;

const ReadOnlyContact = (props: IReadOnlyContactBlockProps) => {
  const {
    contactType,
    firstName,
    lastName,
    email,
    phone,
    licenceNumber,
    type = "general",
  } = props;
  return (
    <Box marginY="small" className="ReadOnlyContact">
      <Stack>
        <HeadingText>{contactType}</HeadingText>
        <Columns
          collapseBelow="sm"
          space={{
            xs: "xlarge",
            md: "medium",
          }}
        >
          <Column width="1/2">
            <ReadOnlyFieldWrapper value={firstName}>
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    First Name
                  </Text>
                  <Text>{firstName}</Text>
                </Stack>
                <Divider />
              </Stack>
            </ReadOnlyFieldWrapper>
          </Column>
          <Column width="1/2">
            <ReadOnlyFieldWrapper value={lastName}>
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    Last Name
                  </Text>
                  <Text>{lastName}</Text>
                </Stack>
                <Divider />
              </Stack>
            </ReadOnlyFieldWrapper>
          </Column>
        </Columns>
        {type === "general" && (
          <Columns
            collapseBelow="sm"
            space={{
              xs: "xlarge",
              md: "medium",
            }}
          >
            <Column width="1/2">
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    Phone
                  </Text>
                  <Text>{phone}</Text>
                </Stack>
                <Divider />
              </Stack>
            </Column>
            <Column width="1/2">
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    Email
                  </Text>
                  <Text>{email || "N/A"}</Text>
                </Stack>
                <Divider />
              </Stack>
            </Column>
          </Columns>
        )}
        <Columns
          collapseBelow="sm"
          space={{
            xs: "xlarge",
            md: "medium",
          }}
        >
          <Column width="1/2">
            <ReadOnlyFieldWrapper value={licenceNumber}>
              <Stack space="xsmall">
                <Stack space="xxsmall">
                  <Text variant="body-small" tone="neutralLight">
                    {type === "general" ? "Licence Number" : "ASP Number"}
                  </Text>
                  <Text>{licenceNumber}</Text>
                </Stack>
                <Divider />
              </Stack>
            </ReadOnlyFieldWrapper>
          </Column>
        </Columns>
      </Stack>
    </Box>
  );
};

export default ReadOnlyContact;
